import { create } from 'zustand';
import { ViewType, Challenge } from '@/types';

interface AppState {
  currentView: ViewType;
  currentChallenge: Challenge | null;
  isLoading: boolean;
  error: string | null;

  // UI state
  wheelValue: number;

  // Actions
  setCurrentView: (view: ViewType) => void;
  setCurrentChallenge: (challenge: Challenge | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setWheelValue: (value: number) => void;
  clearError: () => void;
  resetApp: () => void;
}

export const useAppStore = create<AppState>((set, get) => ({
  currentView: 'home',
  currentChallenge: null,
  isLoading: false,
  error: null,
  wheelValue: 0,

  setCurrentView: (view: ViewType) => {
    set({ currentView: view });
  },

  setCurrentChallenge: (challenge: Challenge | null) => {
    set({ currentChallenge: challenge });
  },

  setLoading: (loading: boolean) => {
    set({ isLoading: loading });
  },

  setError: (error: string | null) => {
    set({ error });
  },

  setWheelValue: (value: number) => {
    set({ wheelValue: value });
  },

  clearError: () => {
    set({ error: null });
  },

  resetApp: () => {
    set({
      currentView: 'home',
      currentChallenge: null,
      isLoading: false,
      error: null,
      wheelValue: 0,
    });
  },
}));
